import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  //   FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { BsAndroid2, BsApple } from "react-icons/bs";
import Header from "../components/Header";
import styled from "styled-components";
import { RiTwitterXFill } from "react-icons/ri";

const Section = styled.div`
  background-color: var(--yellow);
`;
const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 20px;
  padding-top: 40px;

  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }

  > div {
    display: flex;
    justify-content: center;

    @media (max-width: 991px) {
      text-align: center;
      display: unset;
    }

    > div {
      text-align: center;
    }

    h2 {
      font-size: 18px;
      font-weight: 500;
      font-family: var(--casanova);
      color: var(--white);
      margin: 15px 0px;
    }

    ul {
      list-style: none;
      padding-left: 0;

      > li {
        margin: 12px 0px;

        > a {
          color: var(--white);
          text-decoration: underline;
          font-size: 14px;
          font-family: var(--montserrat);
        }
      }
    }
  }
`;

const FooterMain = styled.div`
  margin-top: 100px;
  padding-bottom: 50px;
  background-color: var(--yellow);
  .social_links {
    display: flex;
    justify-content: space-between;
    padding-top: 30px;
    @media screen and (max-width: 767px) {
      align-items: center;
      flex-direction: column;
      justify-content: center;
      gap: 20px;
    }
    > .app_link {
      > p {
        font-size: 16px;
        margin-bottom: 15px;
        text-align: center;
      }
      > .links {
        align-items: center;
        display: flex;
        justify-content: center;
        > a {
          color: #f2f2f2;
          font-size: 20px;
          margin: 0 15px;
        }
      }
    }
  }
  .copyright_txt {
    display: block;
    font-size: 16px;
    margin: 30px auto 0;
    text-align: center;
    width: 70%;
  }
`;
const Sitemap = () => {
  return (
    <>
      <Header />
      <Section>
        <div className="container">
          <Content className="sitemap_links">
            <div>
              <div>
                <h2>Company</h2>
                <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div>
                <h2>Legal & Policies</h2>
                <ul>
                  <li>
                    <Link to="/legal-disclaimer">Legal Disclaimer</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policies</Link>
                  </li>

                  <li>
                    <Link to="/term-and-condition">Terms & Conditions</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div>
                <h2>Partner</h2>
                <ul>
                  <li>
                    <Link to="/become-our-partner">Become Our Partner </Link>
                  </li>
                  <li>
                    <Link to="/investment">Investment </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div>
                <h2>Quick Links</h2>
                <ul>
                  <li>
                    <Link to="/careers">Careers</Link>
                  </li>
                  <li>
                    <Link to="/news-update">News & Updates</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div>
                <h2>Arcaptor Technologies</h2>
                <ul>
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                </ul>
              </div>
            </div>
          </Content>
        </div>
        <FooterMain className="footer_main txt_color">
          <div className="container">
            <div className="social_links">
              <div className="app_link">
                <p>Connect with us</p>
                <div className="links">
                  <Link
                    to="https://www.instagram.com/arcaptor?igsh=NzZ2aXN6a2xiMWM3"
                    target="_blank"
                    title="Instagram"
                    rel="nofollow noopener"
                  >
                    <FaInstagram />
                  </Link>
                  <Link
                    to="https://www.youtube.com/@arcaptortechnologies"
                    target="_blank"
                    title="Youtube"
                    rel="nofollow noopener"
                  >
                    <FaYoutube />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/company/arcaptor-technologies/"
                    target="_blank"
                    title="Linkedin"
                    rel="nofollow noopener"
                  >
                    <FaLinkedin />
                  </Link>
                  <Link
                    to="https://www.facebook.com/arcaptor"
                    target="_blank"
                    title="Facebook"
                    rel="nofollow noopener"
                  >
                    <FaFacebookF />
                  </Link>
                  <Link
                    to="https://x.com/Arcaptortech"
                    target="_blank"
                    title="Twitter"
                    rel="nofollow noopener"
                  >
                    <RiTwitterXFill />
                  </Link>
                </div>
              </div>
              <div className="app_link">
                <p>Download our official app</p>
                <div className="links">
                  <Link
                    to="#!"
                    title="Download Android App"
                    rel="nofollow noopener"
                  >
                    <BsAndroid2 />
                  </Link>
                  <Link
                    to="#!"
                    title="Download IOS App"
                    rel="nofollow noopener"
                  >
                    <BsApple />
                  </Link>
                </div>
              </div>
            </div>
            <p className="copyright_txt">
              Copyright © ARCAPTOR TECHNOLOGIES PRIVATE LIMITED. All rights
              reserved
            </p>
          </div>
        </FooterMain>
      </Section>
    </>
  );
};

export default Sitemap;
